import React from 'react';
import Sidebar from '../components/Sidebar';
import { TermsDocumentContent } from '../components/legal/LegalDocumentContent';

const Terms = () => (
  <div className="flex h-screen overflow-hidden bg-slate-50/50 font-inter text-blue-900">
    <Sidebar />
    <main className="flex-1 overflow-y-auto p-12"><div className="max-w-4xl"><TermsDocumentContent /></div></main>
  </div>
);
export default Terms;
